import { CartAddEvent } from '@theme/events';

/**
 * Intercepts pricing card "Order Now" forms: adds via Cart AJAX API, updates cart UI immediately, then redirects if requested.
 * @param {SubmitEvent} e
 */
async function handlePricingCardSubmit(e) {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.hasAttribute('data-pricing-card')) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) return;

  const quantity = Math.max(1, parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10) || 1);
  const returnTo = form.querySelector('input[name="return_to"]')?.value?.trim() || '';

  const submitBtn = form.querySelector('button[type="submit"]');
  submitBtn?.setAttribute('disabled', '');

  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity }],
      }),
    });

    const data = await res.json();

    const failed =
      !res.ok ||
      data?.status === 422 ||
      data?.status === 'bad_request' ||
      (typeof data?.status === 'number' && data.status >= 400);

    if (failed) {
      const msg =
        (typeof data?.description === 'string' && data.description) ||
        (typeof data?.message === 'string' && data.message) ||
        'Unable to add to cart';
      window.alert(msg);
      return;
    }

    const cartRes = await fetch(`${Theme.routes.cart_url}.js`);
    if (!cartRes.ok) throw new Error('Cart fetch failed');
    const cart = await cartRes.json();

    const productId = form.dataset.lineItemProductId || '';

    document.dispatchEvent(
      new CartAddEvent(cart, 'pricing-cards', {
        source: 'pricing-cards',
        itemCount: cart.item_count,
        productId,
      })
    );

    if (returnTo) {
      const checkoutUrl = returnTo.startsWith('http')
        ? returnTo
        : new URL(returnTo.startsWith('/') ? returnTo : `/${returnTo}`, window.location.origin).href;
      requestAnimationFrame(() => {
        window.location.assign(checkoutUrl);
      });
    }
  } catch (err) {
    console.error(err);
    window.alert('Unable to add to cart. Please try again.');
  } finally {
    submitBtn?.removeAttribute('disabled');
  }
}

if (!/** @type {Window & { __pricingCardsCartBound?: boolean }} */ (window).__pricingCardsCartBound) {
  /** @type {Window & { __pricingCardsCartBound?: boolean }} */ (window).__pricingCardsCartBound = true;
  document.addEventListener('submit', handlePricingCardSubmit, true);
}
